import { render, staticRenderFns } from "./SevkList.vue?vue&type=template&id=01643caa&"
import script from "./SevkList.vue?vue&type=script&lang=js&"
export * from "./SevkList.vue?vue&type=script&lang=js&"
import style0 from "./SevkList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports